module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page notification-page margin-top-header",
    class: {
      'mx-5': _vm.activeTab == 'activity'
    }
  }, [_c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active tab-active': _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [(!_vm.onMobile) ? _c('label', {
      staticClass: "nav-label __tabs",
      class: [tab.id],
      on: {
        "click": function($event) {
          _vm.setTab(tab.id)
        }
      }
    }, [_c('span', {
      staticClass: "__tab dflex align-center"
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(tab.title) + "\n            ")]), _vm._v(" "), (!_vm.isActiveTab(tab.id) && tab.badge > 0) ? _c('span', {
      staticClass: "dot_notifications"
    }, [_c('v-icon', {
      attrs: {
        "size": "1"
      }
    }, [_vm._v("circle")])], 1) : _vm._e()]) : (_vm.onMobile && tab.title != 'SMS') ? _c('label', {
      staticClass: "nav-label __tabs",
      class: [tab.id],
      on: {
        "click": function($event) {
          _vm.setTab(tab.id)
        }
      }
    }, [_c('span', {
      staticClass: "__tab dflex align-center"
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(tab.title) + "\n            ")]), _vm._v(" "), (!_vm.isActiveTab(tab.id) && tab.badge > 0) ? _c('span', {
      staticClass: "dot_notifications"
    }, [_c('v-icon', {
      attrs: {
        "size": "1"
      }
    }, [_vm._v("circle")])], 1) : _vm._e()]) : _vm._e()])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.activeTab === 'activity') ? _c('Activity', {
    attrs: {
      "isComp": ""
    }
  }) : (_vm.activeTab === 'messages') ? _c('Messages', {
    staticClass: "mt-1"
  }) : (_vm.activeTab === 'sms') ? _c('SMS', {
    staticClass: "mt-1"
  }) : (_vm.activeTab === 'paidToShare') ? _c('getPaidToShare') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e218cfce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/index.vue
// module id = 1857
// module chunks = 180